export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Has Rated',
        category: ['User', 'Ratings'],
        description: 'Whether the user has rated the game or not.',
        summarise: {
            template: {
                yes: 'User has rated the game',
                no: 'User has not rated the game'
            }
        }
    }
}